import React from 'react';
import { useAppDispatch, useCallback, useAppSelector } from 'hooks';
import { SignUpForm } from 'components';
import { type SignUpFormDto, type SignUpUserRequestItem } from 'types/types';
import { userActions } from 'utils/store';
import { UserRole } from 'types/enums';
import { getFacilitiesId } from 'utils';

export const RegisterAdminScreen = () => {
  const dispatch = useAppDispatch();

  const data = useAppSelector((state) => state.user.data);
  const isAdmin = data?.role === UserRole.ADMIN;

  const handleFormSubmit = useCallback(
    (payload: SignUpFormDto) => {
      const { study, facilities, ...data } = payload;

      const patient = {};
      const formattedFacilities = facilities?.length ? getFacilitiesId(facilities) : [];

      const newUser: SignUpUserRequestItem = {
        ...data,
        email: data?.email,
        study,
        patient,
        facilities: formattedFacilities,
      };

      dispatch(userActions.createAdmin(newUser));
    },
    [dispatch],
  );

  return <SignUpForm onSubmit={handleFormSubmit} isAdmin={isAdmin} title='Admin Account Data' />;
};
